import type { ProjectMemberEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const PersonIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<circle cx="8" cy="6" r="2.5" />
		<path d="M3 13c0-2.5 2.25-4 5-4s5 1.5 5 4" />
	</svg>
)

export function ProjectMemberRow({ event }: { event: ProjectMemberEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const target = event.payload.targetDisplayName
	const copy =
		event.type === "project.member_added"
			? t.journal.events.projectMemberAdded
			: t.journal.events.projectMemberRemoved
	return (
		<JournalRowShell
			icon={<PersonIcon />}
			headline={interpolate(copy.label, { actor, target })}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor, target })}
		/>
	)
}
